module.exports = __webpack_public_path__ + "img/shape_red_arrows.ac9178d1.png";